'use strict';

import './VZQuantitySelector';
import './VZVariationAttribute';
import './VZPorting';

class VZProductCard extends HTMLElement {
    constructor() {
        super();
        this.sidebar = document.querySelector('.js-configurator-sidebar');
        this.isOneNet = this.dataset.configuratorType === 'one-net';
        this.hardwarePhoneThresholdBtn = document.querySelector('.js-hardware-phone-treshold-btn');
    }

    static updateJourneyModal(fragment) {
        const journeyModal = document.querySelector('vz-journey-modal');
        if (journeyModal) {
            journeyModal.replaceWith(fragment.content.querySelector('vz-journey-modal'));
        }
    }

    static updateChatInfo(fragment) {
        // Update the hidden input field for chat info
        const activeConfiguratorGroup = document.querySelector('#activeConfiguratorGroup');
        if (activeConfiguratorGroup) {
            activeConfiguratorGroup.value = fragment.content.querySelector('#activeConfiguratorGroup').value;

            // Manually dispatch change event as programmatic changes to an input field don't natively trigger an event
            const event = new Event('change');
            activeConfiguratorGroup.dispatchEvent(event);
        }
    }

    connectedCallback() {
        this.addEventListener('variationChange', this.onVariationChange);
        this.hardwarePhoneThresholdBtn?.addEventListener('click', VZProductCard.removeShowMoreBtn.bind(this));
    }

    disconnectedCallback() {
        this.hardwarePhoneThresholdBtn?.removeEventListener('click', VZProductCard.removeShowMoreBtn.bind(this));
    }

    onVariationChange(evt) {
        const { response } = evt.detail;
        const fragment = document.createElement('template');
        fragment.innerHTML = response;
        this.updateCard(fragment.content.querySelector('vz-product-card').outerHTML);
        this.updateSideBar(fragment);
        this.checkOneNetSeats(fragment);
        this.constructor.updateJourneyModal(fragment);
        this.constructor.updateChatInfo(fragment);
    }

    updateCard(productCardHTML) {
        if (this.outerHTML) this.outerHTML = productCardHTML;
    }

    updateSideBar(fragment) {
        this.sidebar.dispatchEvent(
            new CustomEvent('variationChange', {
                detail: {
                    fragment: fragment
                }
            })
        );

        // Set the postcode on the current configuration
        const postCodeCheck = document.querySelector('[is="vz-postcode-check"]');
        const MACDconfigurator = document.querySelector('.js-macd-configurator');
        if (postCodeCheck && !MACDconfigurator) {
            postCodeCheck.setAddress();
        }
    }

    checkOneNetSeats(fragment) {
        // If one-net, and no seat is selected OR the number of seatsSelected is below seatsThreshold, dispatch an event to disable the configurator.
        if (this.isOneNet) {
            const { shouldDisableSubmit } = fragment.content.querySelector('[data-should-disable-submit]').dataset;
            const allQuantitySelectors = [...this.querySelectorAll('.js-quantity-field')];
            const combinedQuantity = allQuantitySelectors.reduce((total, currentElement) => total + parseInt(currentElement.value, 10), 0);

            document.dispatchEvent(
                new CustomEvent('oneNet:seatSelection', {
                    detail: {
                        isOneNetSeatSelected: combinedQuantity > 0,
                        areOneNetSeatsBelowThreshold: shouldDisableSubmit && shouldDisableSubmit === 'true'
                    }
                })
            );

            if (fragment.content.querySelector('.js-pdp-error')) {
                [...document.querySelectorAll('.js-pdp-submit-button button')].forEach((button) => {
                    button.classList.add('pe-none', 'opacity-50');
                    button.setAttribute('disabled', '');
                });
            }
        }
    }

    /**
     * Removes the Hardware Phones show more button when clicked
     * @param {Event} e - The event object.
     */
    static removeShowMoreBtn(e) {
        e.target.parentElement.remove();
    }
}

export default window.customElements.get('vz-product-card') || VZProductCard;

if (!window.customElements.get('vz-product-card')) {
    window.customElements.define('vz-product-card', VZProductCard);
}
